module.exports = __webpack_public_path__ + "static/media/no-product-image.f26efdcf.webp";